// helpers
import { ApiHelper } from 'shared/helpers/api';
import { getCMSURL, ROUTES } from 'shared/api/urls';
import { getDomainConfig } from 'shared/domainConfig/helpers';

// @ts-ignore
import logger from 'shared/logger';

// defs
import { WebAppType } from 'shared/store/app/types';
import { WEB_APP_TYPE } from 'shared/constants';

interface CMSPageProps {
  headers: Record<string, string>;
  pageId: string;
  isMobile?: boolean;
  webAppType: WebAppType;
}

interface DomainConfig {
  [key: string]: string;
}

// constants
const DOMAIN_CONFIG: DomainConfig = {
  NYKAA_FASHION: 'fashion',
  FOOT_LOCKER: 'footlocker',
};

const PLATFORM = {
  [WEB_APP_TYPE.ANDROID]: 'app',
  [WEB_APP_TYPE.IOS]: 'app',
  [WEB_APP_TYPE.MWEB]: 'mobile',
  [WEB_APP_TYPE.DESKTOP]: 'desktop',
};

export const getCMSPageData = ({
  headers,
  pageId,
  isMobile,
  webAppType,
}: CMSPageProps): Promise<object> => {
  const searchParams = new URLSearchParams('');
  const deviceType = isMobile ? PLATFORM[WEB_APP_TYPE.MWEB] : PLATFORM[WEB_APP_TYPE.DESKTOP];
  const { API } = getDomainConfig();

  searchParams.append('deviceType', deviceType);
  searchParams.append('domainId', DOMAIN_CONFIG[API.DOMAIN_PARAM]);
  searchParams.append('platform', PLATFORM[webAppType]);

  if (pageId) {
    searchParams.append('pageId', pageId);
  }

  const url = getCMSURL(ROUTES.CMS) + '?' + searchParams.toString();

  return ApiHelper(url, { headers })
    .then(async (response: Response) => {
      try {
        if (response.ok === false) {
          logger.error({ ERROR: response, METHOD_NAME: 'getCMSPageData' });
          return Promise.reject({ status: response.status, data: response });
        }

        return await response.json();
      } catch (e) {
        logger.error({
          message: 'try block failed',
          ERROR: e,
          METHOD_NAME: 'getCMSPageData',
        });
        return Promise.reject({ status: 500 });
      }
    })
    .catch((err) => {
      logger.error({ ERROR: err, METHOD_NAME: 'getCMSPageData' });
      return Promise.reject({ status: 500 });
    });
};
